<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Fuel type">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="fueltype">Fuel type</label>
              <input type="text" 
              class="form-control" 
              id="fueltype" 
              placeholder="Fuel type"
              v-model="fueltype">
              <div class="invalid-feedback" v-if="errors.fueltype">{{ errors.fueltype[0] }}</div>
            </div>
            <div class="form-group">
                <label for="fuelCostPerL">Fuel cost/L</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="fuelCostPerL" 
                placeholder="Fuel cost/L"
                v-model="fuelCostPerL">
                <div class="invalid-feedback" v-if="errors.fuelCostPerL">{{ errors.fuelCostPerL[0] }}</div>
            </div>
            <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as fuelTypeService from '../../services/fuelType.service';
    export default {
        name:"ModelFuelTypeEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                fueltype:'',
                fuelCostPerL:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters([
                'gettFuelTypeAll'
            ]),
        },
        methods:{
            ...mapActions([
                'fetchFuelTypeAll'
            ]),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },
            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.fueltype = props.rowData.fueltype;
                this.fuelCostPerL = props.rowData.fuelCostPerL;
            },
            fnUpdate:async function(){
                const obj = {
                    "fueltype":this.fueltype,
                    "fuelCostPerL":this.fuelCostPerL,
                    "status":this.status
                }

                try{
                    await fuelTypeService.update(this.id, obj);
                    this.fetchFuelTypeAll();
                    messageService.fnSweetAlertSuccessToast('Fuel type', 'Updated successfully ');
                    this.hideModal();

                    this.id = ''; 
                    this.fueltype = '';
                    this.fuelCostPerL = '';
                    this.status ='';
                }catch(error){
                    messageService.fnSweetAlertErrorToast('Fuel type - update', error.response.data.message);
                }
            }
        }
    }
</script>